import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  arrowNext: {
    visibility: 'hidden',
    padding: 0,
    border: 'none',
    color: theme.palette.secondary.main,
    fontSize: theme.typography.h6.fontSize,
    height: theme.spacing(3),
    width: theme.spacing(3),
    borderRadius: '50%',
    marginRight: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    right: 0,
    zIndex: 999,
    '& :active': {
      borderRadius: '50%',
      background: theme.palette.secondary.main,
    },

    [theme.breakpoints.up('sm')]: {
      visibility: 'visible',
      height: theme.spacing(6),
      width: theme.spacing(6),
      fontSize: theme.typography.h4.fontSize,
      marginRight: 20,
    },
  },

  arrowPrev: {
    visibility: 'hidden',
    padding: 0,
    border: 'none',
    color: theme.palette.secondary.main,
    fontSize: theme.typography.h6.fontSize,
    height: theme.spacing(3),
    width: theme.spacing(3),
    borderRadius: '50%',
    marginLeft: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: 0,
    zIndex: 999,
    '& :active': {
      borderRadius: '50%',
      background: theme.palette.secondary.main,
    },
    [theme.breakpoints.up('sm')]: {
      visibility: 'visible',
      height: theme.spacing(6),
      width: theme.spacing(6),
      fontSize: theme.typography.h4.fontSize,
      marginLeft: 20,
    },
  },

  arrowClass: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  slickDots: {
    position: 'absolute',
    bottom: theme.spacing(3),
    display: 'block',
    width: '100%',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    textAlign: 'center',

    '& li': {
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.spacing(2.5),
      width: theme.spacing(2.5),
      margin: '0 5px',
      padding: 0,
      cursor: 'pointer',
    },
    '& li button': {
      fontSize: 0,
      lineHeight: 0,
      display: 'block',
      width: theme.spacing(1),
      height: theme.spacing(1),
      padding: theme.spacing(0.5),
      cursor: 'pointer',
      color: 'transparent',
      border: 0,
      outline: 'none',
      background: theme.palette.background.extraLightOverlay,
      borderRadius: '50%',
      [theme.breakpoints.up('md')]: {
        height: theme.spacing(2),
        width: theme.spacing(2),
      },
    },
    '& li button:hover, li button:focus ': {
      outline: 'none',
    },
    '& li button:hover:before, li button:focus:before': {
      opacity: 1,
    },
    '& li button:before': {
      fontFamily: 'slick',
      fontSize: '6px',
      lineHeight: theme.spacing(2.5),

      position: 'absolute',
      top: 0,
      left: 0,

      width: theme.spacing(2.5),
      height: theme.spacing(2.5),

      content: '•',
      textAlign: 'center',

      opacity: '.25',
      color: 'black',
    },
    '& li.slick-active button': {
      background: theme.palette.secondary.main,
    },
    '& li.slick-active button:before': {
      opacity: '.75',
      color: 'black',
    },
  },

  slideWrapper: {
    position: 'relative',
  },

  slideContent: {
    position: 'absolute',
    bottom: '25%',
    left: '8%',
    zIndex: 999,
    [theme.breakpoints.up('sm')]: {
      bottom: '15%',
      left: '10%',
    },
  },

  slideTitle: {
    maxWidth: '85%',
    background: theme.palette.background.overlay,
    padding: theme.spacing(1),
    borderTopLeftRadius: theme.spacing(0.5),
    borderTopRightRadius: theme.spacing(0.5),
    borderBottomRightRadius: theme.spacing(0.5),
    '& h3': {
      color: theme.palette.text.white,
      fontFamily: 'Roboto Condensed',
      fontSize: 20,
      margin: theme.spacing(0),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2),
        fontSize: 40,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 60,
      },
    },
  },

  slideSubtitle: {
    maxWidth: '70%',
    background: theme.palette.background.darkOverlay,
    padding: theme.spacing(0.25, 1),
    borderBottomLeftRadius: theme.spacing(0.5),
    borderBottomRightRadius: theme.spacing(0.5),
    '& h3': {
      color: theme.palette.text.white,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: 16,
      margin: theme.spacing(0),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0.25, 2),
        fontSize: 28,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 50,
      },
    },
  },
}))
